import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { NavDropDown } from './components';
import { Link, useLocation } from 'react-router';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import useSchoolContext from 'hooks/useSchoolContext';

interface Props {
  navItems: Array<NavItem | NavDropDown>;
  closeSidebar: () => void;
}

const SidebarNav = ({ navItems, closeSidebar }: Props): JSX.Element => {
  const location = useLocation();
  const schoolContext = useSchoolContext();

  return (
    <Box>
      <Box width={1} paddingX={2} paddingY={1}>
        <Box
          display={'flex'}
          component="a"
          href="/"
          title="theFront"
          width={{ xs: 100, md: 120 }}
        >
          <Box
            component={'img'}
            src={schoolContext?.logoImage}
            maxHeight="75px"
          />
        </Box>
      </Box>
      <List>
        {navItems.map((navItem) => {
          if ('to' in navItem) {
            return (
              <ListItemButton
                key={navItem.title}
                component={Link}
                to={navItem.to}
                selected={navItem.to === location.pathname}
                onClick={() => closeSidebar()}
              >
                <ListItemText>{navItem.title}</ListItemText>
              </ListItemButton>
            );
          }
          return (
            <NavDropDown key={navItem.title} title={navItem.title} items={navItem.items} />
          );
        })}
      </List>

      <Divider />

      <Box paddingX={2} paddingY={2}>
        <Box marginTop={1}>
          <Button
            component={Link}
            to="/login"
            size={'large'}
            variant="contained"
            color="primary"
            fullWidth
            onClick={() => closeSidebar()}
          >
            Login
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default SidebarNav;
